import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Session from '../services/session'
import i from '../imports';
import c from '../components';

const EMPTY_FILTER_VALUE = "empty_filter_value";

const floatingLabelStyle = {
    color: "#FF5563"
}

const underlineStyle = {
    borderColor: "#FF5563"
}

const floatingLabelStyleInForm = {
    color: "#BDBDBD"
}

class TransferDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dateValue: this.props.calcValues.dateValue,
            languageValue: this.props.calcValues.languageValue,
            transfersNumberValue: this.props.calcValues.transfersNumberValue,
            transferNameValue: this.props.currentTransfer.name
        }

    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            dateValue: nextProps.calcValues.dateValue,
            languageValue: nextProps.calcValues.languageValue,
            transfersNumberValue: nextProps.calcValues.transfersNumberValue,
            transferNameValue: nextProps.currentTransfer.name
        });
    }


    handleDateChange = (event, value) => {
        this.setState({
            dateValue: value
        });
    }

    handleLanguageChange = (event, index, value) => {
        this.setState({
            languageValue: value
        });
    }

    handleTransfersNumberChange = (event, index, value) => {
        this.setState({
            transfersNumberValue: value
        });
    }



    render() {

        let currentTransfer = this.props.currentTransfer;

        let test_title = this.props.form_title;

        return (
            <c.FormDialog
                updateCalcValues={this.props.updateCalcValues}
                form_title={this.props.form_title}
                form_description={this.props.form_description}
                onClose={this.props.onClose}
                openDialog={this.props.openDialog}
                calcValues={this.state}
                requestType ='transferRequest'
            >

                <i.Row>
                    <i.Col xs={12} sm={6} md={6}>
                        <i.DatePicker
                            fullWidth
                            floatingLabelStyle={floatingLabelStyle}
                            underlineFocusStyle={underlineStyle}
                            underlineStyle={underlineStyle}
                            floatingLabelText={Session.model.common.words.date}
                            value={this.state.dateValue}
                            onChange={this.handleDateChange}
                        />
                    </i.Col>
                    <i.Col xs={12} sm={6} md={6} align='left'>

                        {/* <div><span style="height: 100%; width: 100%; position: absolute; top: 0px; right: 0px; overflow: hidden; pointer-events: none; z-index: 1;"></span><svg viewBox="-7 0 24 24" style="  height: 48px; width: 48px; user-select: none; transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;"><path d="M7 10l5 5 5-5z"></path></svg></div> */}
                        <i.SelectField
                            className='select-field'
                            //iconStyle={{ padding:0}}
                            floatingLabelText={Session.model.common.words.language}
                            floatingLabelStyle={floatingLabelStyle}
                            fullWidth
                            value={this.state.languageValue}
                            onChange={this.handleLanguageChange}
                            underlineFocusStyle={underlineStyle} underlineStyle={underlineStyle}
                        >
                            <i.MenuItem value={EMPTY_FILTER_VALUE} primaryText={Session.model.transfers.languages.choose_language} />
                            <i.MenuItem value="Eng" primaryText={Session.model.transfers.languages.en} />
                            <i.MenuItem value="Ru" primaryText={Session.model.transfers.languages.ru} />
                        </i.SelectField>
                    </i.Col>
                </i.Row>
                <i.Row>
                    <i.Col xs={12} sm={6} md={6} align='left'>
                        <i.SelectField
                            className='select-field'
                            floatingLabelText={Session.model.transfers.number_of_guests}
                            floatingLabelStyle={floatingLabelStyle}
                            fullWidth
                            underlineFocusStyle={underlineStyle}
                            underlineStyle={underlineStyle}
                            value={this.state.transfersNumberValue}
                            onChange={this.handleTransfersNumberChange}
                        >
                            <i.MenuItem value={1} primaryText={"1"} />
                            <i.MenuItem value={2} primaryText={"2"} />
                            <i.MenuItem value={3} primaryText={"3"} />
                        </i.SelectField>
                    </i.Col>
                </i.Row>
                <i.Row>
                    <i.Col>
                        <br />
                    </i.Col>
                </i.Row>
                <i.Row>
                    <i.Col >

                        <div>
                            <span style={{ fontWeight: 600, color: "#FF5563" }}>{Session.model.destinations.transfers_in}: </span>
                            <span style={{ fontWeight: 600 }}>{currentTransfer.translations[0].title}</span>
                        </div>

                    </i.Col>
                </i.Row>
                <i.Row>
                    <i.Col>
                        <br />
                    </i.Col>
                </i.Row>
            </c.FormDialog>
        )

    }
}

export { TransferDialog };